(function() {

  const isPageClub = $('body.club').length;
  if(isPageClub) {
    getInstagram();
  }
})();